import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import Preferance from "./preferance";
import MLogin from "./merchantlogin";
import MerchantProductManagement from "./editpage";
import DesignPanel from "./designpanel";
import ReceiptInfoPage from "./fisinfo";
import ExcelFis from "./excelfis";
import BranchesPage from "./branches";
import AppointmentsPage from "./appointments";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<MerchantProductManagement />} />
      <Route path="/mlogin" element={<MLogin />} />
      <Route path="/designpanel" element={<DesignPanel />} />
      <Route path="/ReceiptInfoPage" element={<ReceiptInfoPage />} />
      <Route path="/preferance" element={<Preferance />} />
      <Route path="/Preferance" element={<Preferance />} />
      <Route path="/excelfis" element={<ExcelFis />} />
      <Route path="/branches" element={<BranchesPage />} />
      <Route path="/branches/:branchNumber" element={<BranchesPage />} />
      <Route path="/appointments" element={<AppointmentsPage />} />
      <Route path="/randevular" element={<AppointmentsPage />} />
    </Routes>
  </Router>
);

reportWebVitals();
